var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "table-content" },
        [
          _c("div", [
            _c(
              "div",
              {
                staticClass: "title",
                staticStyle: { width: "350px", display: "inline-block" },
              },
              [
                _vm._v(" 监测任务完成情况 "),
                _vm.selectedRowCount
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          width: "150px",
                          display: "inline-block",
                          "line-height": "20px",
                          color: "darkorange",
                        },
                      },
                      [_vm._v("共选择条")]
                    )
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "btn",
                staticStyle: {
                  width: "calc(100% - 350px)",
                  display: "inline-block",
                  "text-align": "right",
                },
              },
              [_c("a-space")],
              1
            ),
          ]),
          _c(
            "a-config-provider",
            { attrs: { locale: _vm.locale } },
            [
              _c("a-table", {
                attrs: {
                  "data-source": _vm.dataSource,
                  columns: _vm.columns,
                  pagination: _vm.pagination,
                  loading: _vm.loading,
                  "row-key": "id",
                  scroll: { y: 500 },
                },
                on: { change: _vm.onPageChange },
                scopedSlots: _vm._u([
                  {
                    key: "wancheng1",
                    fn: function (text, record) {
                      return [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "deepskyblue",
                              "margin-left": "16px",
                              "margin-right": "16px",
                              "font-weight": "700",
                            },
                          },
                          [_vm._v(_vm._s(text))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "wancheng2",
                    fn: function (text, record) {
                      return [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "deepskyblue",
                              "margin-left": "16px",
                              "margin-right": "16px",
                              "font-weight": "700",
                            },
                          },
                          [_vm._v(_vm._s(text))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "wanchenglv",
                    fn: function (text, record) {
                      return [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "deepskyblue",
                              "margin-left": "16px",
                              "margin-right": "16px",
                              "font-weight": "700",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                Math.round(
                                  ((record.realPickCount +
                                    record.realCheckCount) *
                                    100) /
                                    (record.pickCount + record.checkCount)
                                ) + "%"
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "caozuo",
                    fn: function (text, record) {
                      return [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "link" },
                            on: {
                              click: function ($event) {
                                return _vm.showModal(record)
                              },
                            },
                          },
                          [_vm._v("任务执行详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.modalVisable
        ? _c("detail-modal", {
            attrs: {
              execName: _vm.execName,
              projectId: _vm.projectId,
              execId: _vm.execId,
              visible: _vm.modalVisable,
            },
            on: {
              "update:visible": function ($event) {
                _vm.modalVisable = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }